<template>
  <div class="brochure-navbar">
    <div class="brochure-navbar-action" @click="goBack">
      <BaseIcon icon="west" />
      <BaseText class="hide-small">
        {{ $t("brochure.back") }}
      </BaseText>
    </div>
    <div class="brochure-navbar-title">
      <NuxtLinkLocale
        v-if="shopSlug"
        :to="{
          name: 'slug-shops',
          params: {
            slug: shopSlug,
          },
        }"
      >
        <BaseTitle class="mb-0 mt-0 ellipsis">
          {{ title }}
        </BaseTitle>
      </NuxtLinkLocale>
      <BaseTitle v-else class="mb-0 mt-0 ellipsis">
        {{ title }}
      </BaseTitle>
      <BrochureDate :expire-after="expireAfter" :active-from="activeFrom" />
    </div>
    <div class="brochure-navbar-action end" @click="isIndexOpen = true">
      <BaseText class="hide-small">
        {{ $t("brochure.pagination", [pagenumber + 1, totalPages]) }}
      </BaseText>
      <BaseIcon icon="grid_view" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title?: string;
  expireAfter: string;
  activeFrom: string;
  totalPages: number;
  isIndexOpen: boolean;
  shopSlug?: string;
}>();

const emit = defineEmits(["update:isIndexOpen"]);
const isIndexOpen = useVModel(props, "isIndexOpen", emit);

const pagenumber = useRouteNumberParam("pagenumber", 0);

// Handle the back button
const router = useRouter();
const localePath = useLocalePath();
const historyCount = useRouteHistoryCount();

const goBack = () => {
  // If we have a history count, go back
  if (historyCount.value > 1) {
    router.back();
    return;
  }

  // If there is no route history, go to the home page
  router.push(localePath("/"));
};
</script>

<style lang="scss" scoped>
.brochure-navbar {
  color: $light-100;

  background-color: var(--primary);
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  height: 88px;
  min-height: 88px;
  position: relative;

  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  align-items: center;
  padding: 0 1.5rem;

  z-index: 2;
}

.brochure-navbar-action {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;

  &.end {
    justify-content: flex-end;
  }
}

.brochure-navbar-title {
  min-width: 0;
  text-align: center;
  margin: 0 auto;
}
</style>
